import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../type/user.type";

export const initialState: IUser = {
  _id: "",
  fullname: "",
  username: "",
  email: "",
  avatar: "",
  profile: "",
  accessToken: "",
  followers: [],
  followings: [],
  friendRequest: [],
  friends: [],
  status: [],
};

const UserSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => {
      return action.payload;
    },

    updateUserProfile: (state, action: PayloadAction<Partial<IUser>>) => {
      return { ...state, ...action.payload };
    },

    removeRequest: (state, action: PayloadAction<Partial<IUser>>) => {
      return {
        ...state,
        ...state?.friendRequest?.filter(
          (eachRequest: any) => eachRequest._id === action.payload
        ),
      };
    },
  },
});

export const { setUser, updateUserProfile } = UserSlice.actions;

export default UserSlice.reducer;
